import AllActions from "@/infrastructure/rootAction";
import produce from "immer";
import { getType } from "typesafe-actions";
import * as A from "./actions";

import { defaultState } from "./defaults";

export default (state = defaultState, action: AllActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(A.loadSnapshots):
        draft.setup = action.payload.setup;
        if (action.payload.result) {
          draft.result = action.payload.result;
        }
        break;

      case getType(A.updateStrategy):
        draft.setup.strategy = {
          ...state.setup.strategy,
          ...action.payload
        };
        break;

      case getType(A.updateSetup):
        draft.setup = {
          ...state.setup,
          ...action.payload
        };
        break;

      case getType(A.fetchTickers.request): {
        draft.loading.ticker = "REQUEST";
        break;
      }
      case getType(A.fetchTickers.failure):
        draft.loading.ticker = "FAILURE";
        break;
      case getType(A.fetchTickers.success):
        draft.loading.ticker = "SUCCESS";
        draft.meta.tickers = action.payload;
        break;

      case getType(A.fetchBacktestMeta.request): {
        draft.loading.meta = "REQUEST";
        break;
      }
      case getType(A.fetchBacktestMeta.failure):
        draft.loading.meta = "FAILURE";
        break;
      case getType(A.fetchBacktestMeta.success):
        draft.loading.meta = "SUCCESS";
        draft.meta = action.payload;
        break;

      case getType(A.fetchBacktestResult.request): {
        draft.loading.backtest = "REQUEST";
        break;
      }
      case getType(A.fetchBacktestResult.failure):
        draft.loading.backtest = "FAILURE";
        break;
      case getType(A.fetchBacktestResult.success):
        draft.loading.backtest = "SUCCESS";
        draft.result = action.payload;
        break;
    }
  });
